// @flow
// The record editor's code (RichTextEditor, Tiptap), in a chunk of its own that RecordTextField loads on demand
export const importEditor = (): Promise<any> => import(/* webpackChunkName: "editor" */ './RichTextEditor');
